import React from 'react';
import { connect } from 'react-redux';

import { updateGlove } from '../../actions/creators';
import syncPreview from '../higher-order/SyncPreview';
import CustomPythonButtons from '../CustomPythonButtons';

const Pinky = ({
  customPythons,
  insideCurrentCustomPython,
  onInsideCustomPythonClick,
  outsideCurrentCustomPython,
  onOutsideCustomPythonClick,
}) => (
  <div className="step-item-view-wrap pull-right">
    <CustomPythonButtons
      title="PINKY FINGER INSIDE COLOR"
      className="finger-inside-color-wrap"
      images={customPythons}
      currentCustomImage={insideCurrentCustomPython}
      onClick={onInsideCustomPythonClick}
    />
    <CustomPythonButtons
      title="PINKY FINGER OUTSIDE COLOR"
      className="finger-outside-color-wrap"
      images={customPythons}
      currentCustomImage={outsideCurrentCustomPython}
      onClick={onOutsideCustomPythonClick}
    />
  </div>
);

const mapStateToProps = (state) => {
  const { pinkyInsidePython, pinkyOutsidePython } = state.glove;

  return {
    customPythons: state.builder.leatherColors[state.glove.leatherGrade.id],
    insideCurrentCustomPython: pinkyInsidePython,
    outsideCurrentCustomPython: pinkyOutsidePython,
  };
};

const mapDispatchToProps = dispatch => ({
  onInsideCustomPythonClick: python => dispatch(updateGlove({ pinkyInsidePython: python })),
  onOutsideCustomPythonClick: python => dispatch(updateGlove({ pinkyOutsidePython: python })),
});

export default syncPreview(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Pinky), 'fingerSide');
